<template>
	<div class="container">
		<div class="connetMain">
			<!-- 第一部分公司简介 -->
			<div class="cmp_page_one_side">
				<div class="one_side_title">公司简介</div>
				<div class="one_side_content">
					<div class="one_side_img">
						<img src="../../assets/yunthee/one_side_cmp_bg.png" />
					</div>
					<div class="one_side_int">
						<div class="one_side_int_logo">
							<img :src="logoImg" />
						</div>
						<div class="one_side_int_title">
							专注于智慧解决方案、致力于政企业信息化、数字化转型
						</div>
						<div class="one_side_int_Line"></div>
						<div class="one_side_int_font">
							武汉芸希信息科技有限公司，是一家专注于智慧解决方案、智慧管理平台的高科技企业。致力于政企业信息化、数字化转型，围绕生物科技、地质岩土、燃气管网、智慧学院等行业提供信息化、智慧解决方案。
							公司的3位创始人毕业于武汉大学、华中科技大学，在华为/烽火工作近10年，拥有资深的行业经验，将自己在互联网和IT技术领域的积累和客户的应用相结合，为用户量身定做符合自身场景的最佳互联网以及行业应用解决方案。
						</div>
					</div>
				</div>
			</div>

			<!-- 第二部分公司地图--联系我们 -->
			<div class="cmp_page_two_side">
				<div class="two_side_title">联系我们</div>
				<div class="two_side_content">
					<div class="two_side_content_box">
						<div class="two_content_box_item">
							<div class="cmp_item_img">
								<img src="../../assets/yunthee/cmp_content_img_01.png" />
							</div>
							<div class="cmp_item_title">联系人：张经理</div>
						</div>

						<div class="two_content_box_item">
							<div class="cmp_item_img">
								<img src="../../assets/yunthee/cmp_content_img_02.png" />
							</div>
							<div class="cmp_item_title">电话：18591956346</div>
						</div>

						<div class="two_content_box_item">
							<div class="cmp_item_img">
								<img src="../../assets/yunthee/cmp_content_img_03.png" />
							</div>
							<div class="cmp_item_title">邮箱：zhangdan@yunthee.com</div>
						</div>

						<div class="two_content_box_item">
							<div class="cmp_item_img">
								<img src="../../assets/yunthee/cmp_content_img_04.png" />
							</div>
							<div class="cmp_item_title">
								地址：武汉洪山区华工园三路华中科技大学科技园湖北青创园4栋7层707
							</div>
						</div>
					</div>

					<div class="bodymap">
						<div class="mapmain">
							<el-amap
								vid="amapDemo"
								:center="center"
								:zoom="zoom"
								:plugin="plugin"
								class="amap-demo"
								:events="events"
							>
								<el-amap-marker :label="label" :posinset="center" vid="marker" />
								<el-amap-circle
									vid="circle"
									:center="center"
									:radius="radius"
									fill-opacity="0.2"
									strokeColor="#38f"
									strokeOpacity="0.8"
									fillColor="#38f"
								/>
							</el-amap>
						</div>
					</div>
				</div>
			</div>

			<!-- 第三部分团队活动 -->
			<div class="cmp_page_three_side">
				<div class="three_side_title">团队活动</div>
				<div class="three_side_content">
					<div
						class="three_content_item"
						v-for="(item, index) in teamList"
						:key="'team' + index"
					>
						<img :src="item.photo" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { getLogo, getTeaPhoto } from '@/api/apiCenter'
export default {
	name: 'HelloWorld',
	data() {
		let self = this
		return {
			radius: 100,
			label: {
				content:
					'<div class="tiptitle"><p>武汉芸希信息科技有限公司</p></div>' +
					'<div class="tipcontent"><p>武汉洪山区华工园三路华中科技大学<br/>科技园湖北青创园4栋7层707</p></div>'
			},
			zoom: 12,
			center: [114.401552, 30.453005],
			plugin: [
				{
					pName: 'Scale',
					extensions: 'all',
					buttonPosition: 'LB'
				},
				{
					pName: 'ToolBar',
					extensions: 'all',
					buttonPosition: 'LT'
				},
				{
					pName: 'MapType',
					extensions: 'all',
					buttonPosition: 'RT'
				}
			],

			events: {
				click(e) {
					let { lng, lat } = e.lnglat
					self.lng = lng
					self.lat = lat

					// 这里通过高德 SDK 完成。
					var geocoder = new AMap.Geocoder({
						radius: 1000,
						extensions: 'all'
					})
					geocoder.getAddress([lng, lat], function (status, result) {
						if (status === 'complete' && result.info === 'OK') {
							if (result && result.regeocode) {
								self.address = result.regeocode.formattedAddress
								self.$nextTick()
							}
						}
					})
				}
			},
			lng: '',
			lat: '',

			//公司Logo
			logoImg: '',
			teamList: []
		}
	},
	methods: {
		getCmpLogo() {
			getLogo().then(res => {
				this.logoImg = res.data.data.description
				this.getTeam()
			})
		},
		getTeam() {
			getTeaPhoto().then(res => {
				this.teamList = res.data.data
			})
		}
	},
	mounted() {
		this.getCmpLogo()
	}
}
</script>

<style scoped>
.connetMain {
	width: 100%;
	height: auto;
}

/* 第一部分公司简介 */
.cmp_page_one_side {
	width: 100%;
	height: auto;
}
.one_side_title {
	width: 50%;
	height: 50px;
	margin: 0 auto;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 36px;
	font-family: PingFangSC, PingFangSC-Semibold;
	font-weight: 600;
	text-align: left;
	color: #333333;
}
.one_side_content {
	width: 100%;
	height: 337px;
	margin: 50px auto 0 auto;
	display: flex;
	justify-content: left;
	align-items: center;
}
.one_side_img {
	height: 100%;
	width: auto;
	display: inline-block;
}
.one_side_img img {
	height: 100%;
	width: auto;
}
.one_side_int {
	width: auto;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	margin-left: 58px;
}
.one_side_int_logo {
	width: auto;
	height: 85px;
	display: inline-block;
}
.one_side_int_logo img {
	width: auto;
	height: 85px;
}
.one_side_int_title {
	font-size: 18px;
	font-family: PingFangSC, PingFangSC-Medium;
	font-weight: 500;
	text-align: left;
	color: #333333;
	line-height: 39px;
}
.one_side_int_Line {
	width: 50px;
	height: 4px;
	background: #2468f2;
}
.one_side_int_font {
	font-size: 16px;
	font-family: PingFangSC, PingFangSC-Regular;
	font-weight: 400;
	text-align: left;
	color: #707e8f;
	line-height: 25px;
}

/* 第二部分公司地图 */
.cmp_page_two_side {
	width: 100%;
	height: auto;
	margin-top: 80px;
}
.two_side_title {
	width: 50%;
	height: 50px;
	margin: 0 auto;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 36px;
	font-family: PingFangSC, PingFangSC-Semibold;
	font-weight: 600;
	text-align: left;
	color: #333333;
}
.two_side_content {
	width: 100%;
	height: 1002px;
	margin-top: 30px;
	position: relative;
}
.two_side_content_box {
	width: 60%;
	height: 447px;
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	margin-left: auto;
	margin-right: auto;
	background: #f6f7fb;
	border: 1px solid #e2eaf3;
	box-sizing: border-box;
	padding: 47px 33px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	z-index: 9999;
}
.two_content_box_item {
	width: 100%;
	height: 45px;
	display: flex;
	align-items: center;
	margin-left: 50px;
}
.cmp_item_img {
	width: auto;
	height: 100%;
	margin-right: 42px;
}
.two_content_box_item img {
	width: auto;
	height: 100%;
}
.cmp_item_title {
	font-size: 20px;
	font-family: PingFangSC, PingFangSC-Regular;
	font-weight: 400;
	text-align: left;
	color: #6f7d8e;
	letter-spacing: 2.38px;
}

/* 第三部分团队活动 */
.cmp_page_three_side {
	width: 100%;
	height: auto;
	margin-top: 80px;
}
.three_side_title {
	width: 50%;
	height: 50px;
	margin: 0 auto;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 36px;
	font-family: PingFangSC, PingFangSC-Semibold;
	font-weight: 600;
	text-align: left;
	color: #333333;
}
.three_side_content {
	width: 100%;
	height: auto;
	display: flex;
	justify-content: space-between;
	flex-flow: wrap;
	margin-top: 50px;
}
.three_content_item {
	width: 47%;
	height: auto;
	margin-bottom: 30px;
}
.three_content_item img {
	width: 100%;
	height: auto;
}

.bodymap {
	width: 100%;
	height: auto;
	margin: 50px auto 0 auto;
	position: absolute;
	top: 190px;
}
.bodymap .mapmain {
	width: 100%;
	height: 762px;
	margin: 0 auto;
}
@media screen and (max-width: 1100px) {
}
@media screen and (max-width: 800px) {
}
@media screen and (max-width: 500px) {
}
</style>

<style>
.mapmain .amap-marker-label {
	width: 200px;
	height: 80px;
	border: none !important;
	top: -90px !important;
	left: 20px !important;
	background-color: rgba(255, 255, 255, 0.8);
}
.mapmain .amap-marker-label .tiptitle {
	width: 100%;
	height: 10px;
	text-align: center;
}
.mapmain .amap-marker-label .tiptitle p {
	color: coral;
}
.mapmain .amap-marker-label .tipcontent {
	width: 100%;
	height: 50px;
	text-align: center;
}
.mapmain .amap-marker-label .tipcontent p {
	color: rgb(0, 0, 0);
}
</style>
